import React from "react";
import * as styles from "./empty-state-icon.module.scss";
import { classArr } from "../../helper/style-helper";

export interface EmptyStateIconProps {
	className?: string;
	src: string;
}

export default function EmptyStateIcon(props: EmptyStateIconProps) {
	return (
		<img
			className={classArr(styles.emptyStateIcon, props.className)}
			src={props.src}
		/>
	);
}
